import AreaReader from "../AreaReader/AreaReader";
import TextEditorReader from "../TextEditorReader/TextEditorReader";
import Input from "../Input/Input";
import "./FormReader.scss"
import classNames from "classnames";
import Textarea from "../Input/Textarea";
import RadioSelect from "../RadioSelect/RadioSelect";
import Button from "../Button/Button";
import { ReactComponent as FileSvg} from "../../assets/File-Document.svg";
import Icon from "../Icon/Icon";
import Select from "../Input/Select";
import React from "react";
import CustomerActions from "../../api/CustomerActions";

const FormReader = ({rootItems, droppedItems, className, data, onChange, formId, customerId, url, errors = {}}) => {
    let tripleIndex = 0;

    const handleCustomerFormPdf = (customerId, formId, fileName) => {
        CustomerActions.getPdf(customerId, formId, (fileBlob) => {
            const currentUrl = URL.createObjectURL(fileBlob);
            const a = document.createElement('a');

            a.href = currentUrl;
            a.download = fileName;
            document.body.appendChild(a);

            a.click();
            URL.revokeObjectURL(currentUrl);
        })
    }

    return (
        <div className={classNames("form-reader", className)}>
            {rootItems.map(area => {
                let currentAreaType = area.settings.areaType;
                if (currentAreaType === "area-triple"){
                    if(tripleIndex % 3 === 0){
                        currentAreaType = "area-triple-50"
                    } else {
                        currentAreaType = "area-triple-25"
                    }
                    tripleIndex++;
                }
                return (
                    <AreaReader areaType={currentAreaType}>
                        {droppedItems.filter(item => item.parentId === area.id).map((item, index) => {
                            if (item.type === "text") {
                                return (
                                    <TextEditorReader text={item.settings.textInput}/>
                                )
                            }

                            if (item.type === "input") {
                                switch(item.settings.inputType){
                                    case "string":
                                        return (
                                            <Input
                                                name={item.id}
                                                label={item.settings.title}
                                                required={item.settings.required}
                                                value={data[item.id]}
                                                handleChange={(e) => onChange(item.id, e.target.value)}
                                                description={item.settings.description}
                                                error={errors[item.id]}
                                            />
                                        )

                                    case "number":
                                        return (
                                            <Input
                                                name={item.id}
                                                label={item.settings.title}
                                                required={item.settings.required}
                                                type="number"
                                                inputMode="numeric"
                                                value={data[item.id]}
                                                handleChange={(e) => onChange(item.id, e.target.value)}
                                                description={item.settings.description}
                                                error={errors[item.id]}
                                            />
                                        )

                                    case "date":
                                        return (
                                            <Input
                                                name={item.id}
                                                label={item.settings.title}
                                                required={item.settings.required}
                                                type="date"
                                                value={data[item.id]}
                                                handleChange={(e) => onChange(item.id, e.target.value)}
                                                description={item.settings.description}
                                                error={errors[item.id]}
                                            />
                                        )

                                    case "long":
                                        return (
                                            <Textarea
                                                name={item.id}
                                                label={item.settings.title}
                                                required={item.settings.required}
                                                value={data[item.id]}
                                                handleChange={(e) => onChange(item.id, e.target.value)}
                                                description={item.settings.description}
                                                error={errors[item.id]}
                                            />
                                        )

                                    case "checkbox":
                                        const isChecked = data[item.id] === true || data[item.id] === "true";
                                        return (
                                            <Input
                                                type="checkbox"
                                                layout="inline"
                                                name={item.id}
                                                label={item.settings.title}
                                                checked={isChecked}
                                                handleChange={(e) => onChange(item.id, e.target.checked)}
                                                required={item.settings.required}
                                                description={item.settings.description}
                                            />
                                        )

                                    case "radio":
                                        return (
                                            <RadioSelect
                                                label={item.settings.title}
                                                value={item.id}
                                                name={item.settings.selectedRadioGroup.value}
                                                checked={data[item.settings.selectedRadioGroup.value] === item.id}
                                                onChange={(e) => onChange(item.settings.selectedRadioGroup.value, e.target.value)}
                                                required={item.settings.required}
                                                description={item.settings.description}
                                                error={errors[item.id]}
                                            />
                                        )

                                    case "signature":
                                        if (url === null){
                                            return null;
                                        }
                                        return (
                                            <>
                                                <div className="file-name">
                                                    <Icon svg={FileSvg}/>
                                                    <p>{url}</p>
                                                </div>

                                                <Button onClick={() => handleCustomerFormPdf(customerId, formId, url)} className="download">
                                                    Download
                                                </Button>
                                            </>
                                        )

                                    case "select":
                                        return (
                                            <Select
                                                name={item.id}
                                                label={item.settings.title}
                                                required={item.settings.required}
                                                description={item.settings.description}
                                                options={item.settings.options}
                                                value={item.settings.options.find(opt => opt.value === data[item.id]) || null}
                                                handleChange={(option) => {
                                                    onChange(item.id, option.value)
                                                }}
                                            />
                                        )
                                    default:
                                        return null;
                                }
                            }
                        })}
                    </AreaReader>
                )

            })}
        </div>
    )
}

export default FormReader;